<template>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
  <div class="inscription">
    <main>
      <div class="auth-wrapper d-flex align-items-center py-5">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-xl-8 col-lg-10">
              <div class="auth-card p-4">
                <!-- Header -->
                <div class="text-center mb-4">
                  <img src="../assets/neolink.png" alt="Logo" class="mb-3" style="width: 48px;">
                  <h1 class="fs-2 fw-bold">{{ t('inscription.title') }}</h1>
                  <p class="text-muted">{{ t('inscription.subtitle') }}</p>
                </div>
                
                <!-- ✅ AJOUTER notification de parrainage JUSTE ICI -->
                <div v-if="referralCode" class="alert alert-info mb-4">
  <i class="fas fa-handshake me-2"></i>
  <strong>{{ t('inscription.referral.invited') }}</strong><br>
  {{ t('inscription.referral.code') }} <strong>{{ referralCode }}</strong>
</div>
                
                <!-- Alert notifications -->
                <div class="alert alert-danger" v-if="error" role="alert">
                  {{ error }}
                </div>
                <div class="alert alert-success" v-if="success" role="alert">
                  {{ success }}
                </div>
                
                <form @submit.prevent="handleSubmit">
                  <!-- Full width fields -->
                  <div class="bg-light p-4 rounded mb-3">
                    <!-- Name field -->
                    <div class="mb-3">
                      <input
                        v-model="formData.name"
                        type="text"
                        class="form-control"
                        :placeholder="t('inscription.placeholder.name')"
                        required
                      >
                    </div>

                    <!-- username field -->
                    <div class="mb-3">
                      <div class="input-group">
                        <span class="input-group-text">@</span>
                        <input
                          v-model="formData.username"
                          @input="checkUsernameAvailability"
                          @blur="onUsernameBlur"
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': usernameError, 'is-valid': usernameValid }"
                          placeholder="neolinks.me/yourname"
                          pattern="[a-z0-9]+"
                          minlength="3"
                          maxlength="20"
                        >
                      </div>
                      
                      <div v-if="usernameError" class="invalid-feedback d-block">{{ usernameError }}</div>
                      <div v-if="usernameValid" class="valid-feedback d-block">{{ t('inscription.usernameAvailable') }}</div>
                    </div>

                    <!-- Email field -->
                    <div class="mb-3">
                      <input
                        v-model="formData.email"
                        type="email"
                        class="form-control"
                        :placeholder="t('inscription.placeholder.email')"
                        required
                      >
                    </div>

                    <!-- Country field -->
                    <div class="mb-3">
                      <div class="country-selector" :class="{ 'active': showCountries }">
                        <div class="country-input" @click="showCountries = !showCountries">
                          <span v-if="selectedCountry" class="flag">{{ selectedCountry.flag }}</span>
                          <span class="text">{{ selectedCountry ? selectedCountry.name : 'Sélectionnez votre pays' }}</span>
                          <i class="fas fa-chevron-down"></i>
                        </div>
                        <div v-if="showCountries" class="country-dropdown">
                          <input v-model="countrySearch" placeholder="Rechercher..." class="search-input">
                          <div class="country-list">
                            <div v-for="country in filteredCountries" :key="country.code" 
                                @click="selectCountry(country)" class="country-item">
                              <span class="flag">{{ country.flag }}</span>
                              <span>{{ country.name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Terms checkbox -->
                  <div class="mt-4 mb-4">
                    <div class="form-check">
                      <input
                        v-model="formData.terms"
                        type="checkbox"
                        class="form-check-input"
                        id="terms"
                        required
                      >
                      <label class="form-check-label" for="terms">
                        {{ t('inscription.terms') }}
                      </label>
                    </div>
                  </div>

                  <!-- Buttons -->
                  <div class="d-grid gap-2 mb-4">
                    <!-- Submit button full width -->
                    <button
                      type="submit"
                      class="btn btn-primary w-100"
                      :disabled="isLoading"
                    >
                      {{ isLoading ? t('inscription.loading') : t('inscription.submit') }}
                    </button>

                    <!-- Divider text -->
                    <div class="text-center my-2">
                      <span class="text-muted">{{ t('inscription.or') }}</span>
                    </div>

                    <!-- Login link full width -->
                    <router-link 
                      to="/connexion" 
                      class="btn btn-outline-primary w-100"
                    >
                      {{ t('inscription.loginButton') }}
                    </router-link>
                  </div>

                  <!-- Back link -->
                  <div class="text-center mb-4">
                    {{ t('inscription.backText') }} <router-link to="/" class="text-decoration-none">{{ t('inscription.homeLink') }}</router-link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <TheFooter />
  </div>
</template>

<script>
import TheFooter from "@/components/layout/Footer.vue";
import { dashboardService } from '@/services/api';
import { useTranslation } from '@/composables/useTranslation';
import { countries } from '@/utils/countries';

export default {
  name: "InscriptionView",
  components: {
    TheFooter,
  },
  setup() {
    const { t } = useTranslation()
    return { t }
  },
  data() {
    return {
      // ✅ AJOUTER référence code de parrainage
      referralCode: null,
      
      formData: {
        name: '',
        username: '',
        email: '',
        country: 'DJ',
        terms: false
      },
      usernameError: '',
      usernameValid: false,
      usernameTimeout: null,
      isLoading: false,
      error: '',
      success: '',
      countries,
      selectedCountry: null,
      showCountries: false,
      countrySearch: ''
    }
  },
  computed: {
    filteredCountries() {
      if (!this.countrySearch) return this.countries;
      return this.countries.filter(country => 
        country.name.toLowerCase().includes(this.countrySearch.toLowerCase())
      );
    }
  },
  // ✅ AJOUTER created() pour récupérer le code de parrainage
  created() {
    this.referralCode = this.$route.params.referralCode || this.$route.query.ref;
    
    if (this.referralCode) {
      console.log('🔗 Code de parrainage détecté:', this.referralCode);
    }
  },
  mounted() {
    this.selectedCountry = this.countries.find(country => country.code === 'DJ');
  },
  methods: {
    selectCountry(country) {
      this.selectedCountry = country;
      this.formData.country = country.code;
      this.showCountries = false;
      this.countrySearch = '';
    },
    
    async checkUsernameAvailability() {
      const username = this.formData.username.toLowerCase().replace(/[^a-z0-9]/g, '');
      this.formData.username = username;
      
      if (username.length === 0) {
        this.usernameError = '';
        this.usernameValid = false;
        clearTimeout(this.usernameTimeout);
        return;
      }
      
      if (username.length < 3) {
        this.usernameError = 'Minimum 3 caractères';
        this.usernameValid = false;
        return;
      }
      
      clearTimeout(this.usernameTimeout);
      this.usernameTimeout = setTimeout(async () => {
        try {
          const response = await dashboardService.checkUsername(username);
          if (response.data.available) {
            this.usernameError = '';
            this.usernameValid = true;
          } else {
            this.usernameError = response.data.message || 'Déjà pris';
            this.usernameValid = false;
          }
        } catch (error) {
          this.usernameError = 'Erreur de vérification';
          this.usernameValid = false;
        }
      }, 500);
    },

    onUsernameBlur() {
      if (this.formData.username.length === 0) {
        this.usernameError = '';
        this.usernameValid = false;
      }
    },

    // ✅ MODIFIER handleSubmit pour inclure referralCode
    async handleSubmit() {
      this.isLoading = true;
      this.error = '';
      this.success = '';

      try {
        await dashboardService.register({
          name: this.formData.name,
          username: this.formData.username,
          email: this.formData.email,
          country: this.formData.country,
          referralCode: this.referralCode // ✅ AJOUTER cette ligne
        });

        this.success = this.t('inscription.success');
        
        setTimeout(() => {
          this.$router.push('/');
        }, 5000);

      } catch (error) {
        this.error = error.response?.data?.message || this.t('inscription.error');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// Tes styles existants restent identiques
@import '@/assets/styles/main.scss';

:root {
  --bs-primary: #000000;
}

.auth-wrapper {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.auth-card {
  background: white;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

// ... tous tes autres styles existants ...

.country-selector {
  position: relative;
}

.country-input {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  cursor: pointer;
  background: white;
}

.country-input .flag {
  margin-right: 10px;
  font-size: 1.2em;
}

.country-input .text {
  flex: 1;
}

.country-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
  z-index: 1000;
  max-height: 300px;
  overflow: hidden;
  margin-bottom: 5px;
}

.search-input {
  width: 100%;
  padding: 10px;
  border: none;
  border-bottom: 1px solid #eee;
}

.country-list {
  max-height: 250px;
  overflow-y: auto;
}

.country-item {
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
}

.country-item:hover {
  background: #f5f5f5;
}

.country-item .flag {
  margin-right: 10px;
}
</style>